<template>
  <div>
    <div class="d-flex justify-content-between align-items-center">
      <div class="section-title">{{ $t("autoemailreport") }}</div>
      <router-link
        class="btn-blue"
        to="add-auto-emailer-v2">{{ $t("add") }}
      </router-link>
    </div>
    <div class="d-flex justify-content-between align-items-center my-3">
      <div class="d-flex"></div>
      <div class="d-flex align-items-center">

        <router-link
          class="btn-blue"
          to="auto-emailer-v2-logs">{{ $t("logs") }}
        </router-link>

        <FilterByStatusDropdown
          :onSelect="filterIsActive => {
            this.GetAllAutoEmailReport(filterIsActive)
          }"
        />
        <div class>
          <b-dropdown id="listview" name="listview" variant="outline-blue">
            <template v-slot:button-content>
              Viewing&nbsp;
              <strong>{{ selectedvalue }}</strong>
              &nbsp;Of&nbsp;
              <strong>{{ rows }}</strong>
            </template>
            <b-dropdown-item
              v-for="(list, listIndex) in viewingnumbers"
              :key="listIndex"
              href="#"
              @click="onDropDownChangeValue(list.name)"
            >{{ list.name }}
            </b-dropdown-item
            >
          </b-dropdown>
        </div>
      </div>
    </div>

    <div>
      <table class="list-view-table">
        <thead>
        <tr>
          <th class="text-center">{{ $t("report") }} {{ $t("name") }}</th>
          <th class="text-center">{{ $t("cinema") }} {{ $t("name") }}</th>
          <th class="text-center">{{ $t("frequency") }}</th>
          <th class="text-center">{{ $t("screens") }}</th>

<!--          <th class="text-center">-->
<!--            {{ $t("email") }} {{ $t("address") }}-->
<!--          </th>-->
          <th class="text-right">
            <span class="pr-3">{{ $tc("status", 2) }}</span>
          </th>
        </tr>
        </thead>
        <tbody v-if="emailreoprtList.length > 0">
        <tr
          v-for="(emailreport, emailreportIndex) in emailreoprtList"
          :key="emailreportIndex"
        >
          <td class="text-center">{{ getReportName(emailreport.report_type) }}</td>
          <td class="text-center">{{ emailreport.cine_name }}</td>
          <td class="text-center">{{ getFrequencyName(emailreport.frequency_type) }}</td>

          <td class="text-center">{{ emailreport.screens.map(s => s.screen_name).join(',') }}</td>

<!--          <td class="text-center">{{ emailreport.email }}</td>-->
          <td>
            <div class="d-flex align-items-center justify-content-end">
              <StatusDot
                :status="
                    emailreport.is_active === 'Y'
                      ? 'active'
                      : emailreport.is_active === 'N' && 'inactive'
                  "
              />
              <b-dropdown class="ml-4" variant="edit">
                <b-dropdown-item
                  v-on:click="onEmailReport('Edit', emailreport)"
                >
                  <span class="edit-pen"></span>
                  {{ $t("edit") }}
                </b-dropdown-item>
              </b-dropdown>
            </div>
          </td>
        </tr>
        </tbody>
        <tbody v-else>
        <tr>
          <td colspan="3">
            <!-- <div class="h6 my-3 text-center">{{ $t("NoRecords") }}</div> -->
            <NoRecords/>
          </td>
        </tr>
        </tbody>
      </table>
      <b-pagination
        v-model="currentPage"
        :per-page="perPage"
        :total-rows="rows"
        aria-controls="my-table"
        @change="onChangePagination($event)"
      ></b-pagination>
    </div>
  </div>
</template>

<script>
import MasterService from "@/services/MasterService"
import StatusDot from "@/components/Partials/StatusDot.vue"
import FilterByStatusDropdown from "@/components/Partials/FilterByStatusDropdown.vue"
import NoRecords from "@/components/Partials/NoRecords.vue"

export default {
  components: {
    StatusDot,
    FilterByStatusDropdown,
    NoRecords
  },
  data() {
    return {
      perPage: 100,
      currentPage: 1,
      rows: 0,
      selectedvalue: "100",

      viewingnumbers: [],
      emailreoprtList: [],

      //Sorting data
      isSort: false,
      isAscending: true,
      orderby: "",
      columnName: "",

      report_types: [
        {
          report_type: 1,
          name: 'Distributor Summary Report',
        },
        {
          report_type: 2,
          name: 'Aggregator Sales Report',
        },
        {
          report_type: 3,
          name: 'Summary & Performance Report',
        },
      ],
      frequency_type: [
        {
          frequency_type: 1,
          name: 'Daily',
        },
        {
          frequency_type: 2,
          name: 'Weekly',
        },
        {
          frequency_type: 3,
          name: 'Monthly',
        },
      ],
    }
  },
  beforeMount() {
    this.GetAllAutoEmailReport()
    this.getviewingnumber();
  },
  methods: {
    getviewingnumber() {
      this.viewingnumbers = [
        {name: "All", id: 1},
        {name: "10", id: 2},
        {name: "20", id: 3},
        {name: "30", id: 3},
        {name: "40", id: 4},
        {name: "50", id: 5},
        {name: "100", id: 6},
      ]
    },

    getReportName(report_type) {
      return this.getSafe(() => this.report_types.filter(t => t.report_type == report_type)[0].name, 'Report')
    },
    getFrequencyName(frequency_type) {
      return this.getSafe(() => this.frequency_type.filter(t => t.frequency_type == frequency_type)[0].name, 'Frequency')
    },
    onDropDownChangeValue(event) {
      if (event == "All") {
        this.perPage = this.rows
        this.selectedvalue = event
        this.onChangePagination()
      } else {
        console.log("Numbers :", event)
        this.selectedvalue = event
        this.perPage = event
        console.log("perPage :", this.perPage)
        this.onChangePagination()
      }
    },
    /* eslint-disable */
    onChangePagination: function (event) {
      // console.log(event)
      if (event === undefined) {
        this.currentPage = 1
        this.GetAllAutoEmailReport()
      } else {
        this.currentPage = event
        this.GetAllAutoEmailReport()
      }
    },

    onEmailReport: function (type, data) {
      if (type == "Edit") {
        this.$router.push({
          path: `/master/add-auto-emailer-v2/${data.am_id}`,
          query: {am_id: data.am_id}
        })
      }
    },
    //Sort
    onSortValue(columnName, orderby) {
      this.isSort = true
      this.isAscending = !this.isAscending
      this.columnName = columnName
      this.orderby = orderby
      this.GetAllAutoEmailReport()
    },

    GetAllAutoEmailReport: function (filter_is_active = 'Y') {
      let loader = this.$loading.show();

      let body = {
        limit: this.perPage,
        currentPage: this.currentPage,
        columnName: this.columnName,
        orderBy: this.orderby,
        filter_is_active: filter_is_active,
      }

      MasterService.GetAutoEmailReportV2(body).then(response => {
        const {data} = response

        if (data.status) {
          if (data.Records && data.Records.data && data.Records.data.length > 0) {
            this.emailreoprtList = data.Records.data
              .sort((a,b) => {
                let c = true

                c = a.report_type - b.report_type

                if (c === 0) {
                  c = a.cinema_id - b.cinema_id
                }

                if (c === 0) {
                  c = a.frequency_type - b.frequency_type
                }

                if (c === 0) {
                  c = a.am_id - b.am_id
                }

                return c
              })

            this.emailreoprtList.forEach(e => {
              e.email = this.getSafe(() => JSON.parse(e.emails), []).map(e => e.email).join(',')
            })

            if (data.totalRows >= 10) {
              this.rows = data.totalRows
            } else {
              this.rows = data.totalRows
              this.selectedvalue = data.totalRows
            }
          }
        }
      })
      .finally(() => {
        loader.hide()
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Pages/MasterContainer/AutoEmailerV2/listautoemailreport.vue